export const de = {
  // Common
  "common.back": "Zurück",
  "common.cancel": "Abbrechen",
  "common.noItems": "Keine Elemente",
  "common.loading": "Wird geladen...",
  
  // Header
  "nav.features": "Funktionen",
  "nav.howItWorks": "Wie es funktioniert",
  "nav.pricing": "Preise",
  "nav.faq": "FAQ",
  "nav.testimonials": "Schaukasten",
  "nav.contact": "Kontakt",
  "button.getStarted": "Loslegen",
  "button.loading": "Wird geladen...",

  // Auth related
  "auth.signIn": "Anmelden",
  "auth.redirecting": "Weiterleitung...",
  "auth.continueWithGoogle": "Mit Google fortfahren",
  "auth.continueWithGithub": "Mit GitHub fortfahren",
  "auth.or": "ODER",
  "auth.consent.prefix": "Durch Fortfahren stimmen Sie unseren",
  "auth.consent.terms": "Bedingungen",
  "auth.consent.and": "und",
  "auth.consent.privacy": "Datenschutzrichtlinie",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜", // 中文标题

  // Hero Section
  "hero.title": "KI-gestützter Kommunikationsassistent",
  "hero.subtitle": "Verwandeln Sie Ihre Gespräche mit intelligenten, kontextbewussten Antworten, die Ihnen helfen, in jeder Situation effektiver zu kommunizieren.",
  "hero.cta.primary": "Kostenlose Testversion",
  "hero.cta.secondary": "Demo ansehen",
  // New Hero Showcase keys
  "hero.cta.tryNow": "Kostenlos starten",
  "hero.cta.learnMore": "Mehr erfahren",
  "hero.cta.getStarted": "Kostenlos starten",
  "hero.preview.primary": "Ton polieren",
  "hero.preview.secondary": "Übersetzen",
  "hero.preview.tone": "Freundlich",
  "hero.preview.target": "Kunde",
  "hero.hook": "Treten Sie tausenden von Nutzern bei, die ihre Kommunikation täglich verbessern.",
  // Stats
  "stats.users": "Benutzer",
  "stats.replies": "Antworten",
  "stats.languages": "Sprachen",

  // Main Title
  "main.title": "Verwandeln Sie jede Antwort in eine Gelegenheit",

  // Footer Section - 新增
  "footer.company": "Unternehmen",
  "footer.product": "Produkt",
  "footer.support": "Support",
  "footer.legal": "Rechtliches",
  "footer.contactSupport": "Support kontaktieren",
  "footer.helpCenter": "Hilfezentrum",
  "footer.apiDocs": "API-Dokumentation",
  "footer.statusPage": "Statusseite",
  "footer.privacyPolicy": "Datenschutzrichtlinie",
  "footer.termsOfService": "Nutzungsbedingungen",
  "footer.cookiePolicy": "Cookie-Richtlinie",
  "footer.refundPolicy": "Rückerstattungsrichtlinie",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Support",

  // Features Section
  "features.badge": "Leistungsstarke Funktionen",
  "features.title": "Alles was Sie für bessere Kommunikation brauchen",
  "features.subtitle": "Umfassende Tools, die jedes Gespräch effektiver und professioneller machen.",
  "features.scenario.title": "Szenario-Vorlagen",
  "features.scenario.description": "Vorgefertigte Vorlagen für berufliche, persönliche, akademische und professionelle Kommunikation.",
  "features.custom.title": "Benutzerdefinierte Eingaben",
  "features.custom.description": "Fügen Sie beliebige Nachrichten oder Inhalte ein und erhalten Sie kontextuell angemessene Antworten.",
  "features.instant.title": "Reduzierung der Antwortzeit um 90%",
  "features.instant.description": "Erhalten Sie KI-erstellte Antworten in wenigen Sekunden. Kein Warten, nur Ergebnisse.",
  "features.copy.title": "Ein-Klick Kopieren & Teilen",
  "features.copy.description": "Kopieren Sie Antworten sofort oder teilen Sie sie direkt von der Plattform.",

  // How It Works Section
  "howItWorks.badge": "Wie es funktioniert",
  "howItWorks.title": "Drei einfache Schritte zu besserer Kommunikation",
  "howItWorks.subtitle": "Unser optimierter Prozess macht es einfach, professionelle Antworten für jede Situation zu generieren.",
  "howItWorks.step1.title": "Szenario auswählen",
  "howItWorks.step1.description": "Wählen Sie das Kommunikationsszenario, das am besten zu Ihren Bedürfnissen passt.",
  "howItWorks.step2.title": "Inhalt einfügen",
  "howItWorks.step2.description": "Fügen Sie die Nachricht oder den Inhalt hinzu, auf den Sie antworten müssen.",
  "howItWorks.step3.title": "KI-Antwort erhalten",
  "howItWorks.step3.description": "Erhalten Sie eine professionelle, kontextuelle Antwort in Sekunden.",

  // Pricing Section
  "pricing.title": "Preise",
  "pricing.subtitle": "Wählen Sie den Plan, der zu Ihren Kommunikationsbedürfnissen passt",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/Monat",
  "pricing.free.description": "Perfekt zum Ausprobieren unseres Services",
  "pricing.pro.description": "Ideal für Profis und häufige Nutzer",
  "pricing.business.description": "Für Teams und Organisationen",
  "pricing.popular": "Am beliebtesten",
  "pricing.free.feature1": "10 Antworten pro Monat",
  "pricing.free.feature2": "Basis-Szenario",
  "pricing.free.feature3": "Vorlagen definieren & verwenden",
  "pricing.free.feature4": "Historische Antworten",
  "pricing.pro.feature1": "200 Antworten pro Monat",
  "pricing.pro.feature2": "Basis+Custom Szenario",
  "pricing.pro.feature3": "Vorlagen definieren & verwenden",
  "pricing.pro.feature4": "Historische Antworten",
  "pricing.pro.feature5": "Erweiterte Anpassung",
  "pricing.business.feature1": "Unbegrenzte Antworten",
  "pricing.business.feature2": "Team-Zusammenarbeit",
  "pricing.business.feature3": "Basis+Custom Szenario",
  "pricing.business.feature4": "Vorlagen definieren & verwenden",
  "pricing.business.feature5": "Historische Antworten",
  "pricing.business.feature6": "Erweiterte Anpassung",
  "pricing.cta.trial": "Kostenlose Testversion starten",
  "pricing.cta.subscribe": "Abonnieren",
  "pricing.cta.contact": "Vertrieb kontaktieren",
  "pricing.cta.current": "Aktueller Plan",
  "pricing.currentPlan": "Aktueller Plan:",
  "pricing.endDate": "Enddatum des aktuellen Plans:",
  "pricing.autoRenewalDate": "Datum der automatischen Verlängerung des aktuellen Plans:",
  "pricing.answersLeft": "Verbleibende Antworten:",
  "pricing.planName.free": "Free Plan",
  "pricing.planName.proMonthly": "Pro Plan-Monatlich",
  "pricing.planName.proYearly": "Pro Plan-Jährlich",
  "pricing.planName.maxMonthly": "Enterprise Plan-Monatlich",
  "pricing.planName.maxYearly": "Enterprise Plan-Jährlich",
  "pricing.autoRenews": "Ihre Antwortanzahl erneuert sich automatisch am:",
  "pricing.needMore": "Benötigen Sie mehr Antworten?",
  "pricing.upgradeBelow": "Upgraden Sie Ihren Plan unten",
  "pricing.doNotRollOver": "Ungenutzte Antworten verfallen am Zyklusende",
  "pricing.willCancelOn": "Wird storniert am:",
  "pricing.downgradeScheduled": "Herabstufung geplant. Wechselt zu",
  "pricing.on": "am:",
  "pricing.upgradeImmediateTitle": "Plan aktualisiert",
  "pricing.upgradeImmediateDesc": "Ihr neuer Plan ist jetzt aktiv.",
  "pricing.downgradeScheduledTitle": "Herabstufung geplant",
  "pricing.downgradeScheduledDesc": "Ihr Plan ändert sich bei der nächsten Verlängerung.",
  "pricing.cancelScheduledTitle": "Stornierung geplant",
  "pricing.cancelScheduledDesc": "Ihr Plan endet am Periodenende.",
  "pricing.cancelResumedTitle": "Stornierung entfernt",
  "pricing.cancelResumedDesc": "Ihr Abonnement wird weiterhin verlängert.",
  "pricing.cancelPendingDowngrade": "Abbrechen",
  "pricing.pendingDowngradeCanceledTitle": "Ausstehende Herabstufung abgebrochen",
  "pricing.pendingDowngradeCanceledDesc": "Ihr Plan bleibt unverändert.",
  "pricing.pendingDowngradeCancelFailedTitle": "Abbruch fehlgeschlagen",
  "pricing.pendingDowngradeCancelFailedDesc": "Die ausstehende Herabstufung konnte nicht abgebrochen werden. Bitte versuchen Sie es erneut.",
  "pricing.cancelPendingDowngradeProcessing": "Verarbeitung...",
  "pricing.scheduled": "Geplant",
  "pricing.processing": "Verarbeitung...",
  "pricing.getMoreReplies": "Mehr Antworten erhalten",
  "pricing.oneTimeTitle": "Mehr Antworten zu Ihrem Konto hinzufügen",
  "pricing.oneTimeAmountLabel": "Betrag (USD)",
  "pricing.repliesUnit": "Antworten",
  "pricing.oneTimeNotice": "Die Anzahl der gekauften Antworten ist für den aktuellen Monatszyklus gültig. Ein aktives kostenpflichtiges Abonnement ist erforderlich, um sie zu nutzen, und ungenutzte Antworten verfallen.",
  "pricing.cancel": "Abbrechen",
  "pricing.proceed": "Fortfahren",
  "pricing.confirmUpgradeTitle": "Upgrade bestätigen",
  "pricing.confirmDowngradeTitle": "Herabstufung bestätigen",
  "pricing.confirmUpgradeDesc": "Sie sind dabei, Ihren Plan zu aktualisieren. Die Änderung tritt sofort in Kraft und es kann eine anteilige Gebühr (oder Gutschrift) anfallen.",
  "pricing.confirmDowngradeDesc": "Sie planen eine Herabstufung. Ihre aktuellen Funktionen bleiben bis zum Ende des aktuellen Abrechnungszeitraums bestehen.",
  "pricing.downgradeEffectNote": "Eine Herabstufung erstattet den aktuellen Zyklus nicht zurück.",
  "pricing.downgradeApplyNextCycle": "Der neue Plan startet automatisch bei der Verlängerung.",
  "pricing.confirmCancel": "Zurück",
  "pricing.confirmProceedUpgrade": "Jetzt upgraden",
  "pricing.confirmProceedDowngrade": "Herabstufung planen",

  // FAQ Section
  "faq.title": "Häufig gestellte Fragen",
  "faq.subtitle": "Alles was Sie über communicate2win wissen müssen",
  "faq.q1": "Welche Kommunikationsszenarien werden unterstützt?",
  "faq.a1": "Wir unterstützen berufliche Kommunikation, persönliche Beziehungen, akademische Korrespondenz, Kundenservice, Vertriebsaktivitäten und viele andere Szenarien. Unsere KI passt sich an den Kontext und Ton an, der für jede Situation erforderlich ist.",
  "faq.q2": "Wie schnell werden die Antworten generiert?",
  "faq.a2": "Unsere KI generiert Antworten in einigen Sekunden. Wir priorisieren Geschwindigkeit ohne Qualitätseinbußen und stellen sicher, dass Sie sofort professionelle Antworten erhalten.",
  "faq.q3": "Kann ich mein Abonnement jederzeit kündigen?",
  "faq.a3": "Ja, Sie können Ihr Abonnement jederzeit kündigen. Es gibt keine langfristigen Verpflichtungen, und Sie können Ihren Plan nach Bedarf herunter- oder hochstufen.",
  "faq.q4": "Sind meine Daten sicher und privat?",
  "faq.a4": "Ja, wir implementieren umfassende Sicherheitsmaßnahmen einschließlich Verschlüsselung, Zugangskontrollen und regelmäßige Sicherheitsaudits. Ihr Eingabeinhalt und die generierten Antworten werden als Teil Ihrer Benutzerhistorie gespeichert, um Funktionen wie Antwortüberprüfung und Vorlagenerstellung zu ermöglichen. Sie können Ihre Historiedaten jederzeit über Ihre Kontoeinstellungen löschen.",
  "faq.q5": "Was passiert, wenn meine Replies aufgebraucht sind?",
  "faq.a5": "Free-Nutzer müssen bis zum nächsten Monatszyklus warten, bis ihr Reply-Kontingent erneuert wird. Nach einem Upgrade auf Pro können Sie zusätzliche einmalige Replies kaufen; diese gelten nur für den aktuellen Monatszyklus. Enterprise-Nutzer haben unbegrenzte Replies.",
  "faq.q6": "Welche Sprachen werden unterstützt?",
  "faq.a6": "Derzeit unterstützen wir Englisch mit Plänen zur Erweiterung auf Spanisch, Französisch, Deutsch und andere Hauptsprachen. Die KI kann mehrsprachige Kommunikation effektiv handhaben.",
  "testimonials.title": "Kommunikations-Schaukasten",
  "testimonials.subtitle": "Öffentliche Nachrichten, E-Mails und KI-optimierte Antworten, die deine eigenen inspirieren",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Marketing-Direktorin",
  "testimonials.sarah.quote": "communicate2win hat verändert, wie ich Kundenkommunikation handhabe. Die Antworten sind professionell und sparen mir jede Woche Stunden.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Vertriebsleiter",
  "testimonials.michael.quote": "Die beruflichen Szenario-Vorlagen sind unglaublich genau. Meine Antwortrate hat sich seit der Nutzung dieses Tools um 40% verbessert.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Kundenerfolgsleiterin",
  "testimonials.emily.quote": "Perfekt für den Umgang mit schwierigen Kundensituationen. Die KI versteht Kontext und Ton perfekt.",
  "testimonials.more": "Klicken Sie auf die Galerie, um den vollständigen Schaukasten zu erkunden",

  // Interface Elements
  "interface.generating": "Antwort wird generiert...",
  "interface.generate": "KI-Antwort generieren",
  "interface.processing": "Verarbeitung...",
  "interface.advancedOptions": "Erweiterte Optionen",
  "interface.clearInput": "Eingabe löschen",
  "interface.clearDescription": "Beschreibung löschen",
  // Marquee / Logos
  "marquee.trusted": "Partner / Support",
  "marquee.aria": "Markenlogos",

  // History and Showcase
  "history.shareToShowcase": "In Schaukasten teilen",
  "history.showcased": "Im Schaukasten",
  "history.shareConfirm": "Möchten Sie diesen Beitrag wirklich im Schaukasten teilen? Dieser Vorgang kann nur durch Löschen des Beitrags rückgängig gemacht werden.",
  "history.sharedBy": "Geteilt von:",
  "interface.copy": "Kopieren",
  "interface.share": "Teilen",
  "interface.shareResponse": "Antwort Teilen",
  "interface.shareNative": "Über System Teilen",
  "interface.shareEmail": "E-Mail",
  "interface.copyShareText": "Mit Link Kopieren",
  "interface.shareTextCopied": "Antwort und Link in die Zwischenablage kopiert.",
  "interface.ready": "Bereit zum Generieren",
  "interface.enterMessage": "Geben Sie Ihren Nachrichteninhalt ein und wählen Sie ein Szenario, um mit KI-gestützten Antworten zu beginnen.",
  "interface.fast": "Schnell",
  "interface.accurate": "Genau",
  "interface.professional": "Professionell",
  "interface.translation": "Übersetzung",
  "interface.responseDescription": "Hier ist eine reflektierte und professionelle Antwort, die auf den Kontext zugeschnitten ist:",
  "interface.multipleOptions": "Mehrere Antwortoptionen:",
  "interface.option": "Option",
  "interface.noContent": "Kein Inhalt verfügbar",

  // Placeholders
  "placeholder.message": "Fügen Sie die Nachricht ein, auf die Sie antworten, E-Mail-Inhalt oder Text, den Sie erhalten haben...",

  // Dropdowns
  "dropdown.useTemplates": "Vorlagen verwenden",
  "dropdown.scenario": "Kein Szenario",
  "dropdown.target": "Kein Ziel",
  "dropdown.tone": "Kein Ton",

  // Scenario Options
  "scenario.email": "E-Mail",
  "scenario.message": "Nachricht",
  "scenario.workplace": "Arbeitsplatz",
  "scenario.school": "Schule",
  "scenario.home": "Zuhause",
  "scenario.business": "Geschäft",
  "scenario.academic": "Akademisch",
  "scenario.social": "Sozial",
  "scenario.formal": "Formal",
  "scenario.casual": "Lässig",
  "scenario.professional": "Professionell",
  "scenario.personal": "Persönlich",
  "scenario.customerService": "Kundendienst",
  "scenario.interview": "Interview",
  "scenario.presentation": "Präsentation",

  // Target Options
  "target.lover": "Partner",
  "target.friend": "Freund",
  "target.boss": "Chef",
  "target.colleague": "Kollege",
  "target.classmate": "Klassenkamerad",
  "target.parents": "Eltern",
  "target.child": "Kind",
  "target.teacher": "Lehrer",
  "target.student": "Student",
  "target.client": "Kunde",
  "target.customer": "Kunde",
  "target.stranger": "Fremder",
  "target.family": "Familie",
  "target.sibling": "Geschwister",
  "target.neighbor": "Nachbar",
  "target.mentor": "Mentor",
  "target.supplier": "Lieferant",
  "target.serviceProvider": "Dienstleister",
  "target.partner": "Partner",
  "target.subordinate": "Untergebener",

  // Tone Options
  "tone.humorous": "Humorvoll",
  "tone.serious": "Ernst",
  "tone.happy": "Fröhlich",
  "tone.angry": "Wütend",
  "tone.mischievous": "Schelmisch",
  "tone.polite": "Höflich",
  "tone.casual": "Lässig",
  "tone.formal": "Formal",
  "tone.friendly": "Freundlich",
  "tone.confident": "Selbstbewusst",
  "tone.apologetic": "Entschuldigend",
  "tone.enthusiastic": "Begeistert",

  // Status Messages
  "status.copied": "Kopiert!",
  "status.copyDescription": "Antwort in die Zwischenablage kopiert.",
  "status.copyWithTranslationDescription": "Antwort und Übersetzung in die Zwischenablage kopiert.",
  "status.success": "Antwort erfolgreich generiert. ",
  "status.successWithTranslation": "Antwort generiert mit Übersetzung.",
  "status.successWithoutTranslation": "Antwort generiert erfolgreich.",
  "status.error": "Generierung fehlgeschlagen",
  "status.errorDescription": "Antwort konnte nicht generiert werden. Bitte versuchen Sie es erneut.",
  "status.enterContent": "Bitte geben Sie Inhalt ein",
  "status.enterContentDescription": "Fügen Sie die Nachricht hinzu, auf die Sie antworten möchten.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Beschreibung (optional)",
  "restriction.descriptionLabel": "Beschreibung (Nur für Pro / Enterprise Abonnenten)",
  "restriction.proMaxOnly": "* Nur für Pro / Enterprise Abonnenten",
  "restriction.desPrompt": "Geben Sie Kontext, Hintergrundinformationen oder spezifische Anforderungen ein, um bessere Antworten zu erhalten...",

  // Demo functionality for non-logged-in users
  "demo.title": "Wählen Sie eine Nachricht zum Antworten aus",
  "demo.option1": "Verkaufseröffnung (Kaltakquise)",
  "demo.option2": "Umgang mit einer \"Ihr Preis ist hoch\" Anfrage",
  "demo.option3": "Interview-Selbstvorstellung (30-Sekunden-Version)",
  "demo.option4": "E-Mail-Antwort",
  "demo.option5": "Nachfassen bei einem \"gelesen-aber-keine-Antwort\" Interessenten",
  "demo.option6": "Elevator Pitch (30 Sekunden)",
  "demo.runDemo": "Demo Ausführen",
  "demo.inputContent": "Eingabeinhalt:",
  "demo.scenario": "Szenario:",
  "demo.target": "Ziel:",
  "demo.tone": "Ton:",
  "demo.description": "Beschreibung:",

  // Showcase Page
  "showcase.title": "Kommunikations-Schaukasten",
  "showcase.subtitle": "Entdecken Sie inspirierende KI-gestützte Kommunikationen, die von unserer Community geteilt wurden",
  "showcase.userPrefix": "Öffentliche Kommunikationen von",
  "showcase.backAll": "Zurück zum gesamten Schaukasten",
  "showcase.sortBy": "Sortieren nach:",
  "showcase.sort.newest": "Neueste zuerst",
  "showcase.sort.oldest": "Älteste zuerst",
  "showcase.sort.scenario": "Nach Szenario",
  "showcase.sort.target": "Nach Ziel",
  "showcase.sort.tone": "Nach Ton",
  "showcase.filter.scenario": "Szenario:",
  "showcase.filter.target": "Ziel:",
  "showcase.filter.tone": "Ton:",
  "showcase.filter.all": "Alle",
  "showcase.loading": "Schaukasten wird geladen...",
  "showcase.loadingUser": "Benutzerkommunikationen werden geladen...",
  "showcase.loadingMore": "Mehr wird geladen...",
  "showcase.none.userTitle": "Noch keine öffentlichen Kommunikationen",
  "showcase.none.globalTitle": "Noch keine Schaukasten-Einträge",
  "showcase.none.userDesc": "Dieser Benutzer hat noch keine Kommunikationen im Schaukasten geteilt.",
  "showcase.none.globalDesc": "Seien Sie der Erste, der eine KI-Kommunikation im Schaukasten teilt!",
  "showcase.messageDetails": "Nachrichtendetails",
  "showcase.field.date": "Datum",
  "showcase.field.scenario": "Szenario",
  "showcase.field.target": "Ziel",
  "showcase.field.tone": "Ton",
  "showcase.originalMessage": "Originalnachricht",
  "showcase.description": "Beschreibung",
  "showcase.aiResponse": "KI-Antwort",

  // Templates
  "templates.saveAsTemplate": "Als Vorlage speichern",
  "templates.saved": "Vorlage gespeichert",
  "templates.saveSuccess": "Vorlage erfolgreich gespeichert",
  "templates.title": "Meine Vorlagen",
  "templates.new": "Neue Vorlage",
  "templates.loading": "Wird geladen...",
  "templates.none": "Keine Vorlagen gefunden",
  "templates.name": "Name",
  "templates.scenario": "Szenario",
  "templates.target": "Ziel",
  "templates.tone": "Ton",
  "templates.description": "Beschreibung",
  "templates.save": "Speichern",
  "templates.saving": "Speichern...",
  "templates.delete": "Vorlage löschen",
  "templates.deleteConfirm": "Diese Vorlage löschen?",
  "templates.deleteFailed": "Vorlage konnte nicht gelöscht werden",
  "templates.nameRequired": "* Bitte geben Sie einen Vorlagennamen ein",
  "templates.deleteSuccess": "Vorlage erfolgreich gelöscht",
  "templates.saveFailed": "Vorlage konnte nicht gespeichert werden",

  // History Modal additions
  "history.messageDetails": "Nachrichtendetails",
  "history.messageDetailsDesc": "Anzeigen und Verwalten Ihrer Nachrichtendetails, einschließlich der ursprünglichen Eingabe und der KI-generierten Antwort.",
  "history.field.date": "Datum",
  "history.field.scenario": "Szenario",
  "history.field.target": "Ziel",
  "history.field.tone": "Ton",
  "history.originalMessage": "Originalnachricht",
  "history.aiResponse": "KI-Antwort",
  "history.description": "Beschreibung",
  "history.listTitle": "Nachrichtenverlauf",
  "history.listDesc": "Durchsuchen, filtern und verwalten Sie Ihren Konversationsverlauf. Klicken Sie auf eine beliebige Nachricht, um Details anzuzeigen.",
  "history.sortBy": "Sortieren nach:",
  "history.sort.newest": "Neueste zuerst",
  "history.sort.oldest": "Älteste zuerst",
  "history.sort.scenario": "Nach Szenario",
  "history.sort.target": "Nach Ziel",
  "history.sort.tone": "Nach Ton",
  "history.filter.scenario": "Szenario:",
  "history.filter.target": "Ziel:",
  "history.filter.tone": "Ton:",
  "history.filter.all": "Alle",
  "history.loading": "Verlauf wird geladen...",
  "history.loadingMore": "Mehr wird geladen...",
  "history.none": "Keine Nachrichten gefunden",
  "history.showing": "{current} von {total} Nachrichten werden angezeigt",
  "history.allLoaded": "Alle Nachrichten geladen",
  "history.scrollMore": "Nach unten scrollen für mehr",
  "history.loadMoreButton": "Mehr Laden",
  "history.deleteMessage": "Nachricht löschen",
  "history.deleting": "Wird gelöscht...",
  "history.deleteSuccess": "Nachrichteneintrag erfolgreich gelöscht",
  "history.deleteFailed": "Nachrichteneintrag konnte nicht gelöscht werden, bitte versuchen Sie es erneut",
  "history.confirmDeleteTitle": "Löschen bestätigen",
  "history.confirmDeleteSubtitle": "Diese Aktion kann nicht rückgängig gemacht werden",
  "history.confirmDeleteDesc": "Sind Sie sicher, dass Sie diesen Nachrichteneintrag löschen möchten?",
  "history.confirmDeleteAction": "Löschen bestätigen",
  "history.shareTitle": "Im Schaukasten teilen",
  "history.shareSubtitle": "Diese Nachricht öffentlich machen",
  "history.sharing": "Wird geteilt...",
  "history.confirmShareAction": "Teilen bestätigen",
  "history.shareSuccess": "Nachricht erfolgreich im Schaukasten geteilt",
  "history.shareFailed": "Teilen im Schaukasten fehlgeschlagen, bitte versuchen Sie es erneut",

  // User Menu
  "userMenu.myAccount": "Mein Konto",
  "userMenu.history": "Verlauf",
  "userMenu.templates": "Vorlagen",
  "userMenu.signOut": "Abmelden",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "KI-Antwort Vorschau",
  "hero.preview.scenarioLabel": "Szenario",
  "hero.headline": "KI-gestützter Kommunikationsassistent",
  "hero.subheadline": "Verwandeln Sie grobe Ideen in ausgearbeitete, kontextbezogene Antworten in Sekundenschnelle.",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Verkaufseröffnung",
  "demo.shortTitle.priceObjection": "Preisanfrage",
  "demo.shortTitle.interviewIntro": "Vorstellungsgespräch",
  "demo.shortTitle.emailReply": "E-Mail-Antwort",
  "demo.shortTitle.followUp": "Nachverfolgung",
  "demo.shortTitle.elevatorPitch": "Fahrstuhlpitch",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "antwort",
  "demoTabs.inputPrompt": "EINGABE AUFFORDERUNG",
  "demoTabs.context": "KONTEXT",
  "demoTabs.description": "Beschreibung",
  "demoTabs.generate": "Generieren",
  "demoTabs.aiOutput": "KI-AUSGABE",
  "demoTabs.sample": "beispiel",
  "demoTabs.streaming": "Tokens werden gestreamt...",
  "preview.section.scenarioTemplates.title": "Szenario & Vorlagen",
  "preview.section.scenarioTemplates.subtitle": "Wählen Sie schnell ein Szenario oder wenden Sie eine gespeicherte Vorlage an. Vorlagen füllen Beschreibung/Ziel/Ton vorab aus, sodass Sie sofort mit hochwertiger Generierung beginnen können.",
  "preview.section.customInputs.title": "Benutzerdefinierte Eingaben",
  "preview.section.customInputs.subtitle": "Kerneingabe + optionale Beschreibung + erweiterte Szenario-/Ziel-/Ton-Auswahl. Kombinieren Sie frei für kontextbezogene Ergebnisse.",
  "preview.section.cutReplyTime.title": "Antwortzeit um 90% reduzieren",
  "preview.section.cutReplyTime.subtitle": "Vergleichen Sie manuelles Verfassen vs. KI-Unterstützung. Parallele Optionen + integrierte Übersetzungs-/Überarbeitungsschleifen.",
  "preview.section.copyShare.title": "Ein-Klick Kopieren & Teilen",
  "preview.section.copyShare.subtitle": "Mehrere Optionen mit einheitlichen Aktionen oben: Alles kopieren / Teilen / Option kopieren. Übersetzung wird automatisch angehängt.",
  "preview.templates.my": "Meine Vorlagen",
  "preview.templates.new": "Neu",
  "preview.manualFlow": "Manueller Ablauf",
  "preview.aiAssisted": "KI-unterstützt",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Struktur & Ton planen",
  "preview.manualFlow.step2": "Einleitung entwerfen / löschen & neu schreiben",
  "preview.manualFlow.step3": "Höflichkeit & Grammatik anpassen",
  "preview.manualFlow.step4": "Wortwahl nachschlagen + Übersetzung prüfen",
  "preview.manualFlow.step5": "In Zielanwendung einfügen",
  "preview.copyAll": "Alles kopieren",
  "preview.share": "Teilen",
  "preview.enPlusTranslation": "EN + Übersetzung",
  "preview.translationAppendNote": "(*) Übersetzung wird beim Kopieren aller Elemente automatisch angehängt.",
  "preview.field.scenario": "Szenario",
  "preview.field.target": "Ziel",
  "preview.field.tone": "Ton",
  "preview.auto": "Auto",
  "preview.step.pasteOrTemplate": "Anfrage einfügen oder Vorlage auswählen",
  "preview.step.optionalDescription": "(Optional) Beschreibung/Szenario hinzufügen",
  "preview.step.pickOption": "Eine generierte Option auswählen",
  "preview.step.copyShareTranslate": "Ein-Klick Kopieren / Teilen / Übersetzen",
  "preview.time.manual": "5–8 Min",
  "preview.time.ai": "30–40 Sek"
};